import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Icons from '../../icons';
import { updateUserTheme } from '../Header/actions/action';
import { getAdminMenuList, checkPermissionForAdminMenu } from './util'
import { addClass, removeClass, openProfileHash, clearProfileHash } from '../../common/util';
import { showDialogueBox, hideDialogueBox } from '../../components/DialogueBox/actions';
import { PATHS } from '../../router/paths';
import ManageProfile from "./ManageProfile";
import UserImage from '../../components/UserImage/index';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';
import { useModules } from '../../utils/modules';
import { useLegacyHistory } from '../../router/hooks';

const ActionCenter = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { history } = useLegacyHistory();
    const sessionContext = useSelector(selectSessionContextOidc);
    const userView  = sessionContext?.userView;
    const userTheme = sessionContext?.userSettingView?.userTheme;
    const userPermissions = userView?.permissions;
    const orgData = sessionContext?.organizationView

    const companyName = userView?.orgId === orgData?.Id ? orgData?.OrganizationName : null;

    const getAdminMenu = () => {
        const menuList = getAdminMenuList(userPermissions);
        if (menuList.length == 0) {
            return null
        }

        if (checkPermissionForAdminMenu(userPermissions)) {
            return (
                <li className="alignMiddle" data-test="adminSetting">
                    <Icons name="AdminSettings" className="icon mr"/>
                    {getMenuItem(userPermissions)}
                </li>
            )
        }

        function getMenuItem(user) {
            if (user.can_manage_company_profile)
                return <a href={process.env.UrlScheme + "://" + process.env.admin_site_url + "/orgprofile"} className="adminSettingIcon">Admin Settings</a>
            else if (user.can_send_b2b_relationship_request || user.can_accept_reject_b2b_relationship_request || user.can_manage_contracts || user.can_de_associate_b2b_relationship || user.can_add_remove_organization_from_exclude_list || user.can_view_b2b_workload)
                return <a href={process.env.UrlScheme + "://" + process.env.admin_site_url + "/relationships"} className="adminSettingIcon">Admin Settings</a>
            else if (user.can_add_user || user.can_re_assign_a_user || user.can_edit_user || user.can_block_a_user || user.can_reset_password || user.can_view_workload)
                return <a href={process.env.UrlScheme + "://" + process.env.admin_site_url + "/users"} className="adminSettingIcon">Admin Settings</a>
            else if (user.can_manage_settings)
                return <a href={process.env.UrlScheme + "://" + process.env.admin_site_url + "/settings"} className="adminSettingIcon">Admin Settings</a>
            else if (user.can_manage_rules)
                return <a href={process.env.UrlScheme + "://" + process.env.admin_site_url + "/ruleengine"} className="adminSettingIcon">Admin Settings</a>
            else
                return <a className="pointer adminSettingIcon">Admin Settings</a>
        }
    }

    const changeTheme = (event) => {
        const ele = event.currentTarget;
        const currentTheme = document.body.dataset.currenttheme
        if (currentTheme && currentTheme != '')
            removeClass(document.body, currentTheme);

        let selectedTheme = ele.getAttribute("color") + 'Theme';
        document.body.dataset.currenttheme = selectedTheme;
        addClass(document.body, selectedTheme)

        dispatch(updateUserTheme({
            themeType: selectedTheme
        }))
    }

    const manageProfile = () => {
        props.onClose();
        openProfileHash();

        dispatch(showDialogueBox({
            flag: true,
            component: <ManageProfile onClose={() => handleDialogueBoxClose()} />,
            overlayClassName: "modal animated faster fadeIn",
            contentClassName: "modalContent globalSearchModalContent modalFixed animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: true
        })
        )
    }

    const handleDialogueBoxClose = () => {
        dispatch(hideDialogueBox());
        clearProfileHash(history);
    }

    return (
        <div>
            <div className="rightPanelContent userSetting animated faster" data-test="profilePanel">
                <ul className="colFlex separation">
                    <li className="rowFlex rowSpaceBetween" data-test="loggedUser">
                        {userView && <div className="rowFlex userGroup">
                            <div className="userPic userPicIcon">
                                <UserImage 
                                    profileUrl={userView.profileImage} 
                                    profileName={`${userView.firstName} ${userView.lastName}`} 
                                />
                            </div>
                            <div className="userInfo">
                                <h2>{`${userView.firstName} ${userView.lastName}`}</h2>
                                <label>{companyName}</label>
                            </div>
                        </div>}
                        <a className="pointer" onClick={props.onClose}><Icons name="close" className="icon" /></a>
                    </li>
                    <li data-test="manageProfile">
                        <a className="pointer alignMiddle manageProfileIcon" onClick={manageProfile}><Icons name="ManageProfile" className="icon mr" /> Manage profile</a>
                        {/* <a href="/userprofile" className="alignMiddle manageProfileIcon"><svg className="icon mr__12"><use xlinkHref="/SVG/exzeo2x-icon.svg#manageProfile"></use></svg> Manage profile</a> */}
                    </li>
                    {getAdminMenu()}
                </ul>

                <ul className="colFlex">
                    <li className="rowFlex rowSpaceBetween alignMiddle" data-test="themeSettiing">
                        <span className="flexGrow alignMiddle themeIcon"><Icons name="Theme" className="icon mr" /> Themes</span>
                        <div className="themeSelection">
                            <a md="link" onClick={changeTheme} color="purple" className={`pointer defaultTheme theme themePurple mr__1 ${userTheme === "purpleTheme" || userTheme === "defaultTheme" ? 'active' : ''}`}><span data-quicktooltip="Infinity Purple"></span></a>
                            <a md="link" onClick={changeTheme} color="blue" className={`pointer blueTheme theme themeBlue mr__1 ${userTheme === "blueTheme" ? 'active' : ''}`}><span data-quicktooltip="Nebula Blue"></span></a>
                            <a md="link" onClick={changeTheme} color="black" className={`pointer blackTheme theme themeBlack ${userTheme === "blackTheme" ? 'active' : ''}`}><span data-quicktooltip="Groot Brown"></span></a>
                        </div>
                    </li>

                    <li data-test="userContract"><a className="alignMiddle userContractIcon" href="/agreement" target="_blank"><Icons name="UserContract" className="icon mr" /> User Contract</a></li>
                    <li data-test="privacyPolicy"><a className="alignMiddle privacyIcon" href="/privacypolicy" target="_blank"><Icons name="PrivacyPolicy" className="icon mr" /> Privacy Policy</a></li>
                    { 
                        useModules().isModuleEnabled("support") &&
                        <li data-test="help"><a className="alignMiddle helpIcon" href="/support"><Icons name="Help" className="icon mr" /> Help</a></li>
                    }
                    <li data-test="logout">
                        <a
                            className="alignMiddle logoutIcon"
                            href={PATHS.LOGOUT}
                            onClick={(e) => {
                                e.preventDefault();
                                navigate(PATHS.LOGOUT);
                            }}
                        >
                            <Icons name="Logout" className="icon mr" /> Logout
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
}
export default ActionCenter;